module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tr"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb8815bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Table/TrCell.vue
// module id = 1459
// module chunks = 0